import React, { lazy } from 'react';
import { Box, Heading, Flex } from '@chakra-ui/react';
import SuspenseLoader from '@components/atoms/SuspenseLoader';
import SuspenseHelper from '@components/atoms/SuspenseHelper';
import RichText from '@components/atoms/RichText';
import Link from '@components/atoms/Link';
import HeaderFont from '@components/atoms/HeaderFont';
import Wrapper from '@components/atoms/Wrapper';
import { dataLayerClick } from '@helpers/dataLayerPush';

/* Lazy-load share page block to avoid SSR issues */
const ResponsivePlayer = lazy(
  () => import(`@components/molecules/ResponsivePlayer`)
  // eslint-disable-next-line function-paren-newline
);

const VideoListing = ({ data }) => {
  const {
    title,
    subTitle,
    videoId,
    content: {
      data: { content }
    },
    link: { newWindow, title: linkTitle, url }
  } = data;

  return (
    <Box bg="purple.500" mb={{ base: `14`, md: `16` }}>
      <Wrapper narrow>
        <Heading
          as="h3"
          pt={{ base: `12`, md: `20` }}
          pb={{ base: `6`, md: `14` }}>
          <HeaderFont
            color="white"
            textTransform="uppercase"
            fontStyle="italic"
            fontSize={{ base: `4xl`, md: `5xl` }}
            lineHeight={{ base: `2.7rem`, md: `3rem` }}>
            {title}
            <Box
              as="span"
              pl="0.563rem"
              display={{ base: `inline-block`, md: `inline` }}
              color="purple.100">
              {subTitle}
            </Box>
          </HeaderFont>
        </Heading>
        <Flex
          alignItems="center"
          justifyContent="center"
          direction={{ base: `column`, md: `row` }}
          pb={{ base: `12`, md: `20` }}>
          <Box w={{ base: `100%`, md: `50%` }}>
            <SuspenseHelper fallback={<SuspenseLoader />}>
              <ResponsivePlayer
                url={`https://www.youtube.com/watch?v=${videoId}`}
              />
            </SuspenseHelper>
          </Box>
          <Box
            w={{ base: `100%`, md: `50%` }}
            pt={{ base: `6`, md: `10` }}
            pb={{ base: `6`, md: `10` }}
            pl={{ md: `14` }}
            color="white">
            <RichText data={content} />
            <HeaderFont
              color="purple.600"
              textTransform="uppercase"
              fontSize="md">
              <Link
                width={{ base: `100%`, sm: `auto` }}
                textAlign="center"
                href={url}
                target={newWindow ? `_blank` : `_self`}
                bg="white"
                mt="1.5rem"
                p="0.781rem 1.688rem"
                display="inline-block"
                onClick={() => {
                  dataLayerClick({
                    event: `cta_click`,
                    clickText: linkTitle,
                    clickUrl: url
                  });
                }}>
                {linkTitle}
              </Link>
            </HeaderFont>
          </Box>
        </Flex>
      </Wrapper>
    </Box>
  );
};

export default VideoListing;
